import { createFileRoute } from '@tanstack/react-router';
import { RentalSettingsPage } from '@/features/rentals/pages/rental-settings-page';

export const Route = createFileRoute('/_app/settings/rental')({ component: RentalSettingsPage });
